"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormModelFieldSelectList = exports.FormModelMutatorSelectList = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var form_field_1 = require("./form.field");
var FormModelMutatorSelectList = /** @class */ (function (_super) {
    tslib_1.__extends(FormModelMutatorSelectList, _super);
    function FormModelMutatorSelectList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormModelMutatorSelectList.prototype.getOptions = function () {
        var stateValue = this.field.stateValue;
        if (Array.isArray(stateValue.options)) {
            return JSON.parse(JSON.stringify(stateValue.options));
        }
        return [{
                text: FormModelFieldSelectList.UNSELECTED_TEXT,
                value: FormModelFieldSelectList.UNSELECTED_VALUE,
                color: FormModelFieldSelectList.UNSELECTED_COLOR
            }];
    };
    FormModelMutatorSelectList.prototype.option = function (option, index) {
        if (index === void 0) { index = -1; }
        var options = this.getOptions();
        if (index === -1 || index > options.length - 1) {
            options.push(option);
        }
        else {
            options[index] = option;
        }
        this.state.setFieldValue(this.field.fieldId, tslib_1.__assign(tslib_1.__assign({}, this.field.stateValue), { options: options }));
    };
    FormModelMutatorSelectList.prototype.remove = function (index) {
        var options = this.getOptions();
        if (index > options.length) {
            throw new Error('Index is out of bounds ' + index + ' > ' + options.length);
        }
        options.splice(index, 1);
        this.state.setFieldValue(this.field.fieldId, tslib_1.__assign(tslib_1.__assign({}, this.field.stateValue), { options: options }));
    };
    return FormModelMutatorSelectList;
}(form_field_1.FormModelMutatorField));
exports.FormModelMutatorSelectList = FormModelMutatorSelectList;
var FormModelFieldSelectList = /** @class */ (function (_super) {
    tslib_1.__extends(FormModelFieldSelectList, _super);
    function FormModelFieldSelectList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormModelFieldSelectList.isSelectList = function (field) {
        return field.type === core_api_1.IkeFieldType.SELECT_LIST;
    };
    Object.defineProperty(FormModelFieldSelectList.prototype, "Mutator", {
        get: function () {
            if (this._SLMutator == null) {
                this._SLMutator = new FormModelMutatorSelectList(this);
            }
            return this._SLMutator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelFieldSelectList.prototype, "options", {
        get: function () {
            return this.stateValue.options || [{
                    text: FormModelFieldSelectList.UNSELECTED_TEXT,
                    value: FormModelFieldSelectList.UNSELECTED_VALUE,
                    color: FormModelFieldSelectList.UNSELECTED_COLOR
                }];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelFieldSelectList.prototype, "unselectedValue", {
        /**
         * Choose the first element in the array as the unselected value
         * Other wise use the default `unselected`
         */
        get: function () {
            var options = this.options;
            if (!Array.isArray(options) || options.length === 0) {
                return FormModelFieldSelectList.UNSELECTED_VALUE;
            }
            return options[0].value;
        },
        enumerable: false,
        configurable: true
    });
    FormModelFieldSelectList.prototype.createOption = function (text, value, color) {
        this.Mutator.option({ text: text, value: value, color: color });
    };
    FormModelFieldSelectList.prototype.findOption = function (value) {
        var options = this.options;
        for (var i = 0; i < options.length; i++) {
            var opt = options[i];
            if (opt.value === value) {
                return opt;
            }
        }
        // Unselected option not found, use the default
        if (value === FormModelFieldSelectList.UNSELECTED_VALUE) {
            return {
                text: FormModelFieldSelectList.UNSELECTED_TEXT,
                value: FormModelFieldSelectList.UNSELECTED_VALUE,
                color: FormModelFieldSelectList.UNSELECTED_COLOR
            };
        }
        return null;
    };
    FormModelFieldSelectList.UNSELECTED_VALUE = 'unselected';
    FormModelFieldSelectList.UNSELECTED_TEXT = 'Unselected';
    FormModelFieldSelectList.UNSELECTED_COLOR = '#a0aec0';
    return FormModelFieldSelectList;
}(form_field_1.FormModelField));
exports.FormModelFieldSelectList = FormModelFieldSelectList;
//# sourceMappingURL=form.select.list.js.map